module.exports = __webpack_public_path__ + "img/under-maintenance.ac8ae1e5.svg";